import React, { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom"; // Import useLocation
import { InvoiceContext } from "./context/InvoiceContext";
import SelectLevelProducts from "./SelectLevelProducts";
import { db } from '../firebase.config';
import { Snackbar } from "@mui/material";

export default function SelectInvoiceLevelProducts() {
    const navigate = useNavigate();
    const location = useLocation(); // Get location to know where to return

    const { setSelectedItems } = useContext(InvoiceContext);
    
    const [snackbar, setSnackbar] = React.useState({ open: false, message: "", severity: "info" });

    const handleConfirmSelection = (finalItems) => {
        if (!finalItems || finalItems.length === 0) {
            setSnackbar({ open: true, message: "No items selected for Invoice", severity: "error" });
            return;
        }
        
        const itemsWithDefaults = finalItems.map(item => ({
            ...item,
            quantity: item.quantity || 1,
            price: item.price || 0,
            gst: item.gst || 0,
            discount: item.discount || 0,
        }));
        setSelectedItems(itemsWithDefaults);

        const returnPath = location.state?.from || '/invoice-templates/template4';
        navigate(returnPath);
    };

    const handleCancelSelection = () => {
        const returnPath = location.state?.from || '/invoice-templates/template4';
        navigate(returnPath);
    };

    return (
        <>
            <SelectLevelProducts
                db={db}
                title="Product Selection for Invoice"
                onSave={handleConfirmSelection}
                onCancel={handleCancelSelection}
            />
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                message={snackbar.message}
                sx={{ '& .MuiSnackbarContent-root': { backgroundColor: snackbar.severity === 'success' ? '#4caf50' : '#f44336' }}}
            />
        </>
    );
}